module.exports = __webpack_public_path__ + "static/dancing-adfef5cb1425c33eecfb308582ee1754.mp4";